export const USER_SETTINGS_SAVE = 'USER_SETTINGS_SAVE';

export function userSettingsSave(key, settings) {
    return {
        type: USER_SETTINGS_SAVE,
        key: key,
        settings: settings
    };
}